export function createQueueEngine({store, getUser, saveExpense, saveTrip, notify = () => {}, locks}) {
  let inFlight, inFlightUser;
  async function enqueue(type, data) {
    if (!['expense', 'trip'].includes(type) || !data.userId || !data.businessId || !data.values.submissionId) throw new Error('A signed-in owner, Business and record ID are required.');
    const receipt = data.values.receipt ? Array.from(data.values.receipt) : [];
    const draft = await store.insert({key: `${data.userId}:${data.values.submissionId}`, id: data.values.submissionId, type,
      data: {...data, values: {...data.values, receipt}}, createdAt: new Date().toISOString(), status: 'pending'});
    const comparable = value => JSON.stringify({...value, receipt: (value.receipt || []).map(file => ({name: file.name, size: file.size, type: file.type, lastModified: file.lastModified}))});
    if (draft.type !== type || draft.data.businessId !== data.businessId || comparable(draft.data.values) !== comparable({...data.values, receipt})) {
      throw new Error('This record is already saved on the device with different details. Check Device records before trying again.');
    }
    notify();
    return draft;
  }
  async function process(userId) {
    let synced = 0;
    const processed = new Set();
    for (;;) {
    const drafts = (await store.list(userId)).filter(draft => !processed.has(draft.key));
    if (!drafts.length) break;
    for (const draft of drafts) {
      processed.add(draft.key);
      const user = await getUser();
      if (user?.id !== userId) throw new Error('Sign in to the account that saved these records before syncing.');
      await store.update(draft.key, userId, {status: 'syncing', lastError: null}); notify();
      try {
        const save = draft.type === 'expense' ? saveExpense : draft.type === 'trip' ? saveTrip : null;
        if (!save) throw new Error('This record type needs review.');
        await save(userId, draft.data.businessId, {...draft.data.values, submissionId: draft.id}, user.client);
        // Delete only this completed record; never replace a snapshot of the whole queue.
        await store.remove(draft.key, userId); synced++;
      } catch (error) {
        await store.update(draft.key, userId, {status: 'failed', lastError: error.message || 'Unable to sync this record.'});
      }
      notify();
    }
    }
    return {synced, remaining: (await store.list(userId)).length};
  }
  function sync(userId) {
    if (!userId) return Promise.reject(new Error('Sign in before syncing.'));
    if (inFlight) return inFlightUser === userId ? inFlight : inFlight.catch(() => {}).then(() => sync(userId));
    inFlightUser = userId;
    const task = () => process(userId);
    inFlight = (locks ? locks.request('silatrail-device-sync', task) : task()).finally(() => { inFlight = null; notify(); });
    return inFlight;
  }
  return {enqueue, sync};
}
